import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, IconButton } from '@material-ui/core';
import { T } from 'Actions/translate';
import { ArrowBackIos, Done } from '@material-ui/icons';
import { openNotification } from 'Actions/notification';
import { setLanguage, loadLanguage } from 'Utils/jwtUtil';
import util from 'Utils/commonUtil';

class Feedback extends Component {
	state = {
		langValue: loadLanguage()
    }

	setLanguage = (lang) => {
		setLanguage(lang)
		let setlang = loadLanguage()
		this.setState({langValue: setlang})
	}

    render() {
      	const { langValue } = this.state;
		let lang = loadLanguage();

      	return (
	      	<div className='language'>

	      		<Grid className='ship-to-head container-max-width is-fixed' container spacing={0} justify={'space-evenly'}>

		        	<Grid className='back-icon' item xs={3}>
						<IconButton color='inherit' onClick={() => this.props.history.push('/userCenter')}>
		         			<ArrowBackIos/>
		         		</IconButton>
		        	</Grid>

		        	<Grid className={ util.getClassName({
						'page-title': true && lang !== 'EN',
						'en-page-title': true && lang === 'EN'
					}) } item xs={9}>
		            	<span>{T('set_language')}</span>
		        	</Grid>

	      		</Grid>

				<div className="content ">
					<section className="content-box">
						<Grid container spacing={0} justify={'center'}>
							<Grid item xs={12}>
								<div className='lang-list' onClick={ () =>this.setLanguage('CH') }>
									<span className='lang-title'>{T('chinese')}</span>
									{ !langValue ?
										<Done className='lang-icon'/> : 
										langValue && langValue === 'CH' ?
										<Done className='lang-icon'/> : null
									}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='lang-list no-border' onClick={ () =>this.setLanguage('EN') }>
									<span className='lang-title'>{T('english')}</span>
									{ langValue && langValue === 'EN' ?
										<Done className='lang-icon'/> : null
									}
								</div>
							</Grid>
						</Grid>
					</section>
				</div>
	      	</div>
      );
    }

}

const mapStateToProps = state => {
  	return {};
};

const mapDispatchToProps = {
	openNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);
